import { render } from "./partnerTable2.vue?vue&type=template&id=3cf07ee1&scoped=true"
import script from "./partnerTable2.vue?vue&type=script&lang=js"
export * from "./partnerTable2.vue?vue&type=script&lang=js"

import "./partnerTable2.vue?vue&type=style&index=0&id=3cf07ee1&scoped=true&lang=css"

import exportComponent from "/Users/cole/.codex/worktrees/jwt-cookie-expiry/tcd-cube_opr/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cf07ee1"]])

export default __exports__